import { takeEvery, put } from 'redux-saga/effects';
import { isResponseSuccess } from 'helpers';
import types from 'redux/types';
import Services from 'services';
import { BALANCE_URL } from 'consts/api';

const { REQUEST_API_BALANCE, REQUEST_API_BALANCE_SUCCESS, REQUEST_API_BALANCE_FAILED } = types;

export function* getBalance() {
  try {
    // const responseScrub = yield Services.get(`${BALANCE_URL}?type=1`);
    const responseMain = yield Services.get(`${BALANCE_URL}?type=0`);
    if (isResponseSuccess(responseMain.status)) {
      if (typeof responseMain.data === 'number') {
        yield put({
          type: REQUEST_API_BALANCE_SUCCESS,
          payload: { main: responseMain.data, scrub: 0 },
        });
      }
    }
  } catch (error) {
    yield put({ type: REQUEST_API_BALANCE_FAILED, error });
  }
}

export default function* watchGetAPIFunction() {
  yield takeEvery(REQUEST_API_BALANCE, getBalance);
}
